export const groupBy = <T>(items: T[], groupCallback: (item: T) => string) => {
  return items.reduce<Record<string, T[]>>((acc, item) => {
    const key = groupCallback(item);
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});
};
